'use client'
import { Button, CTA, Input, Overlay } from '@/components'
import { Dialog, DialogPanel, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'
import { usePathname } from 'next/navigation'
import { SITE_URL } from '../../constants'

const CTAs = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [copyText, setCopyText] = useState('Copy Link')
  const pathname = usePathname()

  function open() {
    setIsOpen(true)
  }

  function close() {
    setIsOpen(false)
  }

  return (
    <div className="inline-flex gap-2 print:hidden">
      <Button
        type="button"
        renderButton={({ testAttr }) => (
          <span
            role="button"
            tabIndex={0}
            onClick={() => window.print()}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                e.target.click()
              }
            }}
            className={`${testAttr} material-symbols-outlined large-icon cursor-pointer text-secondary hover:opacity-80`}
          >
            print
          </span>
        )}
      />
      <Button
        type="button"
        renderButton={({ testAttr }) => (
          <span
            tabIndex={0}
            role="button"
            onClick={open}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                e.target.click()
              }
            }}
            className={`${testAttr} material-symbols-outlined large-icon cursor-pointer text-secondary hover:opacity-80`}
          >
            share
          </span>
        )}
      />

      <Dialog open={isOpen} as="div" className="relative z-10 focus:outline-none" onClose={close}>
        <Transition
          as={Fragment}
          show={isOpen}
          enter="transition-all ease-in-out duration-300"
          enterFrom="opacity-0 backdrop-blur-none"
          enterTo="opacity-100 backdrop-blur-[.5px]"
          leave="transition-all ease-in-out duration-200"
          leaveFrom="opacity-100 backdrop-blur-[.5px]"
          leaveTo="opacity-0 backdrop-blur-none"
        >
          <div className="fixed inset-0" aria-hidden="true">
            <Overlay gradient="none" color="dark" />
          </div>
        </Transition>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel className="data-[closed]:transform-[scale(95%)] w-full max-w-2xl rounded-xl bg-secondary p-6 py-8 duration-200 ease-out data-[closed]:opacity-0 lg:w-1/3">
              <div className="flex gap-2">
                <Input
                  type="text"
                  value={`${SITE_URL}${pathname}`}
                  readOnly
                  aria-label="Web Page Address"
                ></Input>
                <CTA
                  as="button"
                  className=" text-nowrap"
                  onClick={() => {
                    navigator.clipboard.writeText(`${SITE_URL}${pathname}`)
                    setCopyText('Link Copied')

                    setTimeout(() => {
                      setCopyText('Copy Link')
                    }, 1000)
                  }}
                  link={{ link: '', text: copyText } as Sanity.Link}
                  layout={{
                    size: 'normal',
                    color: 'primary'
                  }}
                />
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default CTAs
